import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { nanoid } from 'nanoid';

const withSpellcheck = editor => {
	const { apply } = editor;

	// Handle's editor's operations event
	// @args: default arguments
	editor.apply = (operation) => {
		const { type, node } = operation;

		// Handle spellcheck field's operations
		if (node && node.type === 'spellcheck') {
			switch (type) {
			case 'insert_node':
				editor.onWordAdd(node.name);
				break;
			case 'remove_node':
				editor.onWordRemove(node.name);
				break;
			default:
				break;
			}
		}

		apply(operation);
	};

	// Add spellcheck field
	editor.addSpellcheck = () => {
		// Focus editor
		ReactEditor.focus(editor);

		// Insert spellcheck field in selection
		Transforms.insertNodes(editor, [{
			type: 'spellcheck',
			name: nanoid(),
			value: '',
			children: [{ text: '' }]
		},
		{ text: ' ' }], {
			hanging: true
		});
	};

	// Remove spellcheck field
	editor.removeSpellcheck = () => {
		// Remove spellcheck field from selection
		Transforms.removeNodes(editor, {
			match: node => node.type === 'spellcheck'
		});

		// Focus editor
		ReactEditor.focus(editor);
	};

	return editor;
};

export default withSpellcheck;